import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AclRole } from '@y42/acl/models';
import { getRoleLabel } from '@y42/acl/util/acl-get-role-label';
import { connectState } from '@y42/angular/util';
import { GitQuery } from '@y42/git';
import { OrgSpaceQuery } from '@y42/org-space/state';
import { map, of } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'y42-git-disabled-commit-dialog',
  templateUrl: './git-disabled-commit-dialog.component.html',
  styleUrls: ['./git-disabled-commit-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GitDisabledCommitDialogComponent {
  constructor(private readonly gitQuery: GitQuery, private readonly orgSpaceQuery: OrgSpaceQuery) {}

  readonly state = connectState(this, {
    activeBranchName: this.gitQuery.activeBranchName$,
    activeSpace: this.orgSpaceQuery.active$.pipe(map((space) => space?.name || '')),
    ownerLabel: of(getRoleLabel(AclRole.Owner)),
    administratorLabel: of(getRoleLabel(AclRole.Administrator)),
  });
}
